import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const retrieveCodes = async (code: string | string[], search: string, locale = 'en', system: string | string[] = undefined) => {
  try {
    const response = await apiClient.multilingualCode.getCodes.mutation({
      body: { locale: locale.toLowerCase(), code, search, system },
    });
    if (response.status !== 200) throw response.body;

    return response.body.codes;
  } catch (error) {
    showErrorToast(error, 'Error fetching the codes!');
  }
};
